import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminService } from '../../../admin/admin.service';
import { Application, Unit } from '../../../models/admin-models';
import { distinctUntilChanged, map, debounceTime } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { ReportingService } from '../../reporting.service';
import { saveAs } from '@progress/kendo-file-saver';
import { SessionStorageService } from '../../../services/session-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-reason-text-report',
  templateUrl: './reason-text.component.html',
  styleUrls: ['./reason-text.component.scss'],
  imports: [
    NgxLoadingModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class ReasonTextComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private rptSvc = inject(ReportingService);
  private ss = inject(SessionStorageService);
  dialog = inject(MatDialog);

  @Input() baseUrl;

  reasonUnitsControl = new FormControl();
  filteredUnits;
  selectedUnit;
  reason = { unit: null, app: null };
  applications: Application[] = [];
  units: Unit[] = [] as Unit[];
  loading = false;

  ngOnInit(): void {
    this.ss.get('globals')?.Modules.forEach(el => {
      switch (el.toLowerCase()) {
        case 'aw':
          this.applications.push({
            name: 'Annuity Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'iw':
          this.applications.push({
            name: 'Investment Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'li':
          this.applications.push({
            name: 'Life Insurance Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'pp':
          this.applications.push({
            name: 'Product Profiler',
            value: el.toLowerCase(),
          });
          break;
        case 'rb':
          this.applications.push({
            name: 'Control KB (RB)',
            value: el.toLowerCase(),
          });
          break;
        default:
          break;
      }
    });
    this.getReasonUnits();
  }

  getReasonText() {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.loading = true;
        const iosSafari =
          this.pltfrm.IOS ||
          (navigator?.['userAgentData']?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

        this.rptSvc.getReasonText(this.reason.unit, this.reason.app).subscribe({
          next: data => {
            const filename = `${this.reason.unit}_ReasonTextReport.xlsx`;

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });
              this.loading = false;
            };
          },
          error: error => {
            this.loading = false;
            console.error(error);
          },
        });
      }
      dialogRef = null;
    });
  }

  getReasonUnits() {
    this.reasonUnitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.reasonUnitsControl.value;
      })
    ) {
      this.reasonUnitsControl.setValue(null);
    }
  }
}
